import { axiosObject } from "../config";

export default function deleteFileByUuid(
  //   owner_identifier: Array<string>,
  //   owner_service: string
  uuid: string
) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/files/_delete";
    let payload = {
      filterBy: [{ attribute: "uuid", op: "eq", value: uuid }],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
